export const SIDEBAR_POSITION = {
  LEFT: "left",
  RIGHT: "right",
};

export const SIDEBAR_BEHAVIOR = {
  STICKY: "sticky",
  FIXED: "fixed",
  COMPACT: "compact",
};

export const LAYOUT = {
  FLUID: "fluid",
  BOXED: "boxed",
};

export const THEME = {
  DEFAULT: "default",
  COLORED: "colored",
  DARK: "dark",
  LIGHT: "light",
};

export const THEME_PALETTE_LIGHT = {
  primary: "#3B82EC",
  "primary-dark": "#1659c7",
  "primary-light": "#84aef2",
  secondary: "#495057",
  success: "#4BBF73",
  info: "#1F9BCF",
  warning: "#f0ad4e",
  danger: "#d9534f",
  white: "#fff",
  "gray-100": "#f4f7f9",
  "gray-200": "#e2e8ee",
  "gray-300": "#dee6ed",
  "gray-400": "#ced4da",
  "gray-500": "#adb5bd",
  "gray-600": "#6c757d",
  "gray-700": "#495057",
  "gray-800": "#020202",
  "gray-900": "#212529",
  black: "#000",
};

export const THEME_PALETTE_DARK = {
  ...THEME_PALETTE_LIGHT,
  "primary-dark": "#84aef2",
  "primary-light": "#1659c7",
  white: "#293042",
  "gray-100": "#3e4555",
  "gray-200": "#545968",
  "gray-300": "#696e7b",
  "gray-400": "#7f838e",
  "gray-500": "#9498a1",
  "gray-600": "#a9acb3",
  "gray-700": "#bfc1c6",
  "gray-800": "#d4d6d9",
  "gray-900": "#eaeaec",
  black: "#fff",
};

export const PLANS = [
  {
    name: "Osnovni",
    price: 399,
    stripeId: "price_1MBJFgCPQ0K5Y0YtPXljF29i", //TODO: from config
    features: [
      "1 uporabnik",
      "do 100 obvestil",
      "do 100 filtrov",
      "osveževanje vsakih 5 minut",
    ],
  },
  {
    name: "Napredni",
    price: 599,
    stripeId: "price_1MBJFgCPQ0K5Y0YtDd8NULnm", //TODO: from
    featured: true,
    features: [
      "do 5 uporabnikov",
      "do 500 obvestil",
      "do 500 filtrov",
      "osveževanje vsako minuto",
      "mesečno poročilo",
    ],
  },
  {
    name: "Premuim",
    price: undefined,
    stripeId: "price_1MBJFgCPQ0K5Y0YtPb5Z2TNR", //TODO: from config
    features: [
      "neomejeno uporabnikov",
      "do 1000 obvestil",
      "neomejeno filtrov",
      "osveževanje večkrat na minuto",
      "mesečno poročilo",
      "napredna analitika",
      "dodatne možnosti obveščanja",
    ],
  },
];
